<template>
    <v-dialog class="outfit-font" scrim="rgba(0, 0, 0, 0.8)" v-model="configurator" :fullscreen="config_fullscreen" persistent :width="config_fullscreen ? '100%':'90%'" :max-width="!config_fullscreen ? '1366px':'100%'" transition="dialog-bottom-transition">
        <v-card :class="GlobalRadius">
            <v-layout class="overflow-y-auto">
                <v-app>
                    <v-app-bar density="comfortable" :elevation="0" :class="`${GlobalRadius} config-app-bar border-b position-fixed`">
                        <v-btn icon="mdi-close" dark @click="Close"/>
                        <v-spacer/>
                        <span class="clip-text-1-lines" v-text="selected_copier?.name"/>
                        <v-spacer/>
                        <v-btn icon="mdi-menu" v-if="is_mobile && config_drawer" dark @click="ToggleDrawer"/>
                        <v-btn icon="mdi-fullscreen" dark @click="ToggleFullscreen"/>
                    </v-app-bar>
                    <v-main class="bg-white">
                        <v-card-text>
                            <slot name="main"/>
                        </v-card-text>
                    </v-main>
                    <v-navigation-drawer width="350" border="1" v-model="DrawerProxy" location="right">
                        <v-app class="pa-5" style="height:fit-content">
                            <v-card>
                                <v-app-bar elevation="0" density="compact" :color="ConfigElementsColor">
                                    <slot name="drawerAppbar"/>
                                </v-app-bar>
                                <v-main>
                                    <slot name="drawer"/>
                                </v-main>
                            </v-card>
                        </v-app>
                        <slot name="drawerActions"/>
                    </v-navigation-drawer>
                </v-app>
            </v-layout>
            <div class="configurator-footer border-t pa-0 pl-3 pr-3" style="max-height: fit-content">
                <ShopLink v-if="!is_mobile"/>
                <v-spacer/>
                <CheckoutBtn/>
            </div>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import CheckoutBtn from "@/components/catalog/CheckoutBtn.vue"
import ShopLink from "@/components/misc/ShopLink.vue"

const store = useGlobalsStore()
const {
  is_mobile,
  configurator,
  config_drawer,
  selected_copier,
  config_fullscreen,
  ConfigElementsColor
} = storeToRefs(store)

const DrawerProxy = computed({
  get() {
    return config_drawer.value
  },
  set(val) {
    store.SetAnyState({ target: 'config_drawer', value: val })
  }
})

const GlobalRadius = computed(() => {
  return config_fullscreen.value ? '' : 'global-radius'
})

function ToggleDrawer() {
  store.SetAnyState({
    target: 'config_drawer',
    value: !config_drawer.value
  })
}

function ToggleFullscreen() {
  store.SetAnyState({
    target: 'config_fullscreen',
    value: !config_fullscreen.value
  })
}

function Close() {
  store.SetAnyState({
    target: 'configurator',
    value: !configurator.value
  })
}

function HandleEscape(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    Close()
  }
}

onMounted(() => {
  window.addEventListener('keydown', HandleEscape)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', HandleEscape)
})
</script>

<style scoped>
.configurator-footer {
  display: flex;
  justify-content: space-between;
}
@media(max-width: 600px) {
    .configurator-footer {
        display: block;
    }
}
.config-app-bar {
    border-bottom-right-radius: 0 !important;
    border-bottom-left-radius: 0 !important
}
</style>
